import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { forkJoin } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class LanguageService {

  languages:any = {};
  settings:any={};
  constructor(private http:HttpClient) {
    
  }

  setLanguage() {
    forkJoin(this.http.get("../../assets/language/lan."+  localStorage.getItem("lan")+".json"), this.http.get("../../assets/language/setting."+  localStorage.getItem("lan")+".json")).subscribe(res=>{
      this.languages = res[0];
      this.settings = res[1];
    })
  }

  translate(input){
      return this.languages[input];
  }

  translateSetting(input) {
    return this.settings[input];
  }





  
}
